import { useEffect, useState } from "react";

const industries = [
  "Construction",
  "Renovation",
  "IT & Software",
  "Manufacturing",
  "Marketing",
  "Logistics",
  "Engineering",
  "Interior Design",
  "Event Production",
  "Energy",
];

export function IndustriesSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.getElementById("industries-section");
    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  return (
    <section id="industries-section" className="relative py-24 md:py-32 lg:py-40 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h3 className="text-sm font-mono text-muted-foreground mb-8 uppercase tracking-wider">
            Industries served
          </h3>
          <div className="flex flex-wrap gap-4 md:gap-6">
            {industries.map((industry, index) => (
              <span
                key={index}
                className={`text-lg md:text-xl font-medium text-muted-foreground transition-all duration-700 ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-4"
                }`}
                style={{ transitionDelay: `${50 + index * 30}ms` }}
              >
                {industry}
                {index < industries.length - 1 && <span className="mx-2 text-muted-foreground/30">·</span>}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
